import React, { useState, useContext, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import { Dropdown } from "react-bootstrap";
import ic_filter_chat from "../../assets/images/chat/ic_filter_chat.svg";
import "../../assets/css/main.scss";
import arrow_right from "../../assets/images/chat/arrow_right.svg";
import more_vertical from "../../assets/images/chat/more_vertical.svg";
import { AvatarStack, Button, SearchIconButton } from "../../components/ui";
import ApiConfig from "../../api/ApiConfig";

import { Toast } from "primereact/toast";
import { useMediaQuery } from "react-responsive";
import ChatBox from "./ChatBox";
import { PostCallWithErrorResponse } from "../../api/ApiServices";
import { notifyError, notifySuccess } from "../../toaster/notify";
import ViewMembersModal from "./components/ViewMembersModal";
import CreateSubChannelModal from "./components/CreateSubChannelModal";

const getProjectInitials = (name) => {
  if (!name) return "";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const ChevronIcon = () => (
  <svg
    className="comm-channels__chevron-icon"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M3 1.5L6.5 5L3 8.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Teams = () => {
  const toast = useRef(null);
  const currentRoute = useLocation().pathname;
  const [show, setShow] = useState(false);
  const [activeSidebar, setActiveSidebar] = useState("");
  const [showsubChannelModal, setShowsubChannelModal] = useState(false);
  const [subChannelDetails, setSubChannelDetails] = useState({
    name: "",
    description: "",
    members: [],
  });

  const isMobile = useMediaQuery({
    query: "(max-width: 768px)",
  });

  const [currentTeam, setCurrentTeam] = useState(null);
  const [members, setMembers] = useState([]);

  const {
    currentSChannel,
    getTeams,
    teamMembers,
    loading,
    setLoading,
    sidebar,
    membersArray,
    setSidebar,
    socket,
    Dark,
    setDark,
    projects,
    teams,
    setProjects,
    setTeams,
    activeChat,
    setActiveChat,
    setCurrentSChannel,
    userData,
    permissions,
  } = useContext(AppContext);

  const navigate = useNavigate("");

  const createSubChannel = () => {
    let body = JSON.stringify({
      schannel_name: subChannelDetails.name,
      schannel_description: subChannelDetails.description,
      channel_id: currentTeam,
      members: subChannelDetails.members.map((mem) => mem.id),
    });
    if (
      subChannelDetails?.name === "" ||
      subChannelDetails?.description === "" ||
      subChannelDetails?.members.length === 0
    ) {
      notifyError("Please fill all fields");
    } else {
      setLoading(true);
      PostCallWithErrorResponse(ApiConfig.CREATE_SUB_CHANNEL, body)
        .then((res) => {
          setLoading(false);
          if (res.json.status) {
            notifySuccess(res.json.message);
            setShowsubChannelModal(false);
            setSubChannelDetails({ name: "", description: "", members: [] });
            getTeams();
          } else notifyError(res.json.message);
        })
        .catch((err) => {
          setLoading(false);
          notifyError(err);
        });
    }
  };

  function onSelect(selectedList, selectedItem) {
    setSubChannelDetails({ ...subChannelDetails, members: selectedList });
  }
  function onRemove(selectedList, removedItem) {
    setSubChannelDetails({ ...subChannelDetails, members: selectedList });
  }
  const joinRoom = (schannel_id) => {
    socket.emit("join-room", {
      schannel_id: schannel_id,
    });
  };

  useEffect(() => {
    let newArr =
      Array.isArray(teams) &&
      teams &&
      teams.map((element) => {
        return element?.channel_name === activeChat?.project &&
          activeChat?.project
          ? {
            ...element,
            submenu: true,
          }
          : {
            ...element,
            submenu: false,
          };
      });
    setTeams(newArr);
  }, [activeChat]);

  const buildTeamAvatars = (project) =>
    (project?.subchannel || []).map((sc) => ({
      src: sc.GroupIcon
        ? sc.GroupIcon
        : "",
      name: sc.Team_Channel_Name || project.channel_name || "",
    }));

  return (
    <>
      <div
        className={sidebar ? "" : "cx-active"}
        id="cx-main"
      >
        <div className="comm-layout">
          <Toast ref={toast} />

          <aside className="comm-sidebar">
            <div className="comm-sidebar__header">
              <div className="comm-sidebar__title">
                <label>Teams</label>
              </div>
              <div className="comm-sidebar__actions">
                <SearchIconButton
                  size="md"
                  variant="ghost"
                  aria-label="Search teams"
                />
              </div>
            </div>
            <div className="comm-divider"></div>
            <div className="comm-sidebar__list mt-3">
              <div className="comm-sidebar__section-label mx-2 px-2">
                <div className="left">
                  <label htmlFor="">Your Teams</label>
                </div>
              </div>

              {Array.isArray(teams) && teams.length === 0 && (
                <div className="comm-teams__list">
                  <div className="comm-teams__empty">
                    <div className="comm-teams__empty-illustration">
                      <img src={ic_filter_chat} alt="" aria-hidden="true" />
                    </div>
                    <div className="comm-teams__empty-title">
                      No teams yet
                    </div>
                    <div className="comm-teams__empty-text">
                      Create a team to start collaborating with your members.
                    </div>
                    {permissions && permissions["Create Team"] && (
                      <Button
                        variant="primary"
                        size="md"
                        onClick={() => navigate("/CreateTeam")}
                      >
                        Create Team
                      </Button>
                    )}
                  </div>
                </div>
              )}

              {Array.isArray(teams) && teams.length > 0 && (
                <div className="comm-channels">
                  {teams.map((project, index) => {
                    const subchannelCount = project?.subchannel?.length || 0;
                    const totalUnread =
                      project?.subchannel?.reduce(
                        (sum, c) => sum + Number(c?.unread_count || 0),
                        0
                      ) || 0;
                    const isOpen = !!project?.submenu;
                    const groupClass = [
                      "comm-channels__group",
                      isOpen && "comm-channels__group--open",
                    ]
                      .filter(Boolean)
                      .join(" ");
                    const teamAvatars = buildTeamAvatars(project);

                    return (
                      <div
                        className={groupClass}
                        key={"project" + project.channel_id}
                      >
                        <div
                          className="comm-channels__item"
                          onClick={() => {
                            socket &&
                              socket.emit("get-general-members", {
                                schannel_id:
                                  project.subchannel &&
                                  project.subchannel[0].Team_Channel_Id,
                              });
                            setCurrentTeam(
                              project.subchannel &&
                              project.subchannel[0].Team_Channel_Id
                            );
                            joinRoom(
                              project.subchannel &&
                              project.subchannel[0].Team_Channel_Id
                            );
                          }}
                        >
                          <Link
                            to="#"
                            className="comm-channels__item-main"
                            onClick={() => {
                              setTeams(
                                teams.map((proj, innerIndex) => {
                                  return {
                                    ...proj,
                                    submenu: proj.submenu
                                      ? !proj.submenu
                                      : innerIndex === index,
                                  };
                                })
                              );
                            }}
                          >
                            <span
                              className="comm-channels__chevron"
                              aria-hidden="true"
                            >
                              <ChevronIcon />
                            </span>
                            {teamAvatars.length > 0 ? (
                              <div className="comm-channels__item-tile comm-channels__item-tile--avatars">
                                <AvatarStack
                                  avatars={teamAvatars}
                                  layout="grid"
                                  size="md"
                                />
                              </div>
                            ) : (
                              <div className="comm-channels__item-tile">
                                <span className="comm-channels__item-tile-text">
                                  {getProjectInitials(project?.channel_name)}
                                </span>
                              </div>
                            )}
                            <div className="comm-channels__item-name">
                              {project.channel_name}
                            </div>
                            <div className="comm-channels__item-meta">
                              {totalUnread > 0 && (
                                <span
                                  className="comm-channels__count-badge"
                                  aria-label={`${totalUnread} unread`}
                                >
                                  {totalUnread > 99 ? "99+" : totalUnread}
                                </span>
                              )}
                            </div>
                          </Link>
                          <div className="comm-channels__item-actions">
                            <Dropdown>
                              <Dropdown.Toggle
                                as="button"
                                id={`team-actions-${project.channel_id}`}
                                className="comm-channels__item-action-toggle"
                                aria-label="Team actions"
                              >
                                <img src={more_vertical} alt="" />
                              </Dropdown.Toggle>
                              <Dropdown.Menu
                                as="ul"
                                className="comm-channels__item-menu"
                              >
                                <li
                                  className="comm-channels__item-menu-item"
                                  onClick={() => {
                                    setCurrentSChannel(
                                      project?.subchannel[0]?.Team_Channel_Id
                                    );
                                    setShowsubChannelModal(true);
                                  }}
                                >
                                  Add Sub-channel
                                </li>
                                <li
                                  className="comm-channels__item-menu-item"
                                  onClick={() => setShow(true)}
                                >
                                  View members
                                </li>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </div>

                        {isOpen && (
                          <div className="comm-channels__sublist">
                            {subchannelCount > 0 &&
                              project.subchannel.map((channel) => {
                                const isActive =
                                  currentRoute === "/teams" &&
                                  currentSChannel === channel.Team_Channel_Id;
                                const hasUnread = channel.unread_count > 0;
                                const subItemClass = [
                                  "comm-channels__subitem",
                                  isActive && "comm-channels__subitem--active",
                                  hasUnread && "comm-channels__subitem--unread",
                                ]
                                  .filter(Boolean)
                                  .join(" ");
                                return (
                                  <Link
                                    to="/teams"
                                    key={
                                      "Subchannel" + channel.Team_Channel_Id
                                    }
                                    className={subItemClass}
                                    onClick={() => {
                                      if (
                                        Number(channel?.unread_count) > 0 &&
                                        teams
                                      ) {
                                        setTeams(
                                          teams.map((proj) =>
                                            proj.channel_id !==
                                            project.channel_id
                                              ? proj
                                              : {
                                                ...proj,
                                                subchannel: (
                                                  proj.subchannel || []
                                                ).map((c) =>
                                                  c.Team_Channel_Id ===
                                                  channel.Team_Channel_Id
                                                    ? { ...c, unread_count: 0 }
                                                    : c
                                                ),
                                              }
                                          )
                                        );
                                      }
                                      isMobile
                                        ? setSidebar(false)
                                        : setSidebar(true);

                                      setActiveChat({
                                        pin: false,
                                        ...channel,
                                        project: project.channel_name,
                                        channel_name:
                                          channel.Team_Channel_Name,
                                        channel_id: channel.channel_id,
                                      });
                                      setCurrentSChannel(
                                        channel.Team_Channel_Id
                                      );
                                    }}
                                  >
                                    <span className="comm-channels__subitem-name">
                                      {channel.Team_Channel_Name}
                                    </span>
                                    {hasUnread && (
                                      <span className="comm-channels__subitem-meta">
                                        <span
                                          className="comm-channels__count-badge comm-channels__count-badge--sm"
                                          aria-label={`${channel.unread_count} unread`}
                                        >
                                          {channel.unread_count > 99
                                            ? "99+"
                                            : channel.unread_count}
                                        </span>
                                      </span>
                                    )}
                                  </Link>
                                );
                              })}
                            <button
                              type="button"
                              className="comm-channels__add-sub"
                              onClick={(e) => {
                                e.stopPropagation();
                                setCurrentTeam(project.channel_id);
                                setCurrentSChannel(
                                  project?.subchannel?.[0]?.Team_Channel_Id
                                );
                                setShowsubChannelModal(true);
                              }}
                            >
                              <span
                                className="comm-channels__add-sub-icon"
                                aria-hidden="true"
                              >
                                +
                              </span>
                              <span>Add Sub-channel</span>
                            </button>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <div className="comm-divider mx2"></div>
            <div className="comm-sidebar__section-label px-3" id="invite-people">
              <div className="left">
                <label className="text-grey" htmlFor="">
                  Invite People
                </label>
              </div>
              <div className="right">
                <Link to="#">
                  <img src={arrow_right} alt="" className="pe-1" />
                </Link>
              </div>
            </div>
            <div className="comm-sidebar__section-label px-3" id="invite-people">
              {permissions && permissions["Create Team"] && (
                <div className="left">
                  <label
                    htmlFor=""
                    onClick={() => {
                      navigate("/CreateTeam");
                    }}
                  >
                    Join or Create Team
                  </label>
                </div>
              )}
              <div className="right">
                <Link to="#">
                  <img src={arrow_right} alt="" className="pe-1" />
                </Link>
              </div>
            </div>
          </aside>
          <main className="comm-layout__main">
            <ChatBox isIndivitual={false} />
          </main>
        </div>
      </div>
      {/* View memebers Modal */}
      <ViewMembersModal
        show={show}
        onHide={() => {
          setShow(false);
          setCurrentTeam(null);
          setMembers([]);
        }}
        members={teamMembers}
      />
      {/* Create Sub channel  Modal */}
      <CreateSubChannelModal
        show={showsubChannelModal}
        onHide={() => setShowsubChannelModal(false)}
        subChannelDetails={subChannelDetails}
        onChannelNameChange={(e) =>
          setSubChannelDetails({
            ...subChannelDetails,
            name: e.target.value,
          })
        }
        onChannelDescriptionChange={(e) =>
          setSubChannelDetails({
            ...subChannelDetails,
            description: e.target.value,
          })
        }
        memberOptions={membersArray
          ?.filter((emp) => emp?.User_Id !== Number(userData?.EmpId))
          ?.map((suggetion) => ({
            id: suggetion.User_Id,
            name: suggetion.FirstName + " " + suggetion.LastName,
          }))}
        onMemberSelect={onSelect}
        onMemberRemove={onRemove}
        onCancel={() => setShowsubChannelModal(false)}
        onSubmit={() => createSubChannel()}
        loading={loading}
      />
    </>
  );
};

export default Teams;
